import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Products from "./components/Products/Products";
import Shipping from "./components/Shipping/Shipping";
import Sourcing from "./components/Sourcing/Sourcing";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import TrackingPage from "./pages/TrackingPage";
import AutoCarousel from "./components/AutoCarousel/AutoCarousel";
import FeaturedCard from "./components/FeaturedCard/FeaturedCard";
import FeatureTiles from "./components/FeatureTiles/FeatureTiles";
import Personnel from "./components/Personnel/Personnel";
import Resources from "./components/Resources/Resources";
import Graphs from "./components/Graphs/Graphs";
import FeatureCards from "./components/FeatureCards/FeatureCards";
import WorkflowCard from "./components/WorkflowCard/WorkflowCard";
import styled from "styled-components";
import "./App.css";

const HomePage = styled.div`
  background: #ffffff;
  width: 100%;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  padding-top: 0;
  color: #ffffff;
`;

const HomeContent = styled.div`
  position: relative;
  z-index: 1;
  background: transparent;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
`;

const BaseSection = styled.section`
  background: transparent;
  position: relative;
  width: 100%;
  padding: 0;
  margin-top: 0;
  z-index: 1;

  &:first-child {
    margin-top: 0;
    padding-top: 0;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
        circle at 20% 20%,
        rgba(66, 153, 225, 0.03),
        transparent 25%
      ),
      radial-gradient(
        circle at 80% 80%,
        rgba(66, 153, 225, 0.03),
        transparent 25%
      );
    pointer-events: none;
    z-index: -1;
  }

  @media (max-width: 1024px) {
    padding: 0;
    margin-top: 0;
  }

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 0;
  }
`;

const RegularSection = styled(BaseSection)``;

const ShiftedSection = styled(RegularSection)`
  position: relative;
  padding-top: 120px;

  @media (max-width: 768px) {
    padding-top: 100px;
  }

  @media (max-width: 480px) {
    padding-top: 80px;
  }
`;

const WorkflowSection = styled(RegularSection)`
  position: relative;
  padding-top: 120px;

  @media (max-width: 768px) {
    padding-top: 100px;
  }

  @media (max-width: 480px) {
    padding-top: 80px;
  }
`;

const SourcingSection = styled(RegularSection)`
  position: relative;
  padding-top: 120px;

  @media (max-width: 768px) {
    padding-top: 100px;
  }

  @media (max-width: 480px) {
    padding-top: 80px;
  }
`;

const AnalyticsSection = styled(BaseSection)``;

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <HomePage>
                <HomeContent>
                  <RegularSection id="hero" className="home-section">
                    <Hero />
                  </RegularSection>
                  <RegularSection id="featured">
                    <FeaturedCard />
                    <FeatureTiles />
                  </RegularSection>
                  <RegularSection id="features">
                    <FeatureCards />
                  </RegularSection>
                  <ShiftedSection id="personnel" className="home-section">
                    <Personnel />
                  </ShiftedSection>
                  <WorkflowSection id="workflow" className="home-section">
                    <WorkflowCard />
                  </WorkflowSection>
                  <SourcingSection id="sourcing" className="home-section">
                    <Sourcing />
                  </SourcingSection>
                  <RegularSection id="shipping" className="home-section">
                    <Shipping />
                  </RegularSection>
                  <RegularSection className="home-section">
                    <AutoCarousel />
                  </RegularSection>
                  <AnalyticsSection id="analytics" className="home-section">
                    <Graphs />
                  </AnalyticsSection>
                  <RegularSection id="contact" className="home-section">
                    <Contact />
                  </RegularSection>
                </HomeContent>
                <Footer />
              </HomePage>
            }
          />
          <Route
            path="/products"
            element={
              <div style={{ background: "none" }}>
                <Products />
              </div>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/graphs" element={<Graphs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/resources" element={<Resources />} />
          <Route
            path="/track-order"
            element={
              <div
                style={{
                  background: "#f5f7fa",
                  minHeight: "100vh",
                  color: "#000000",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxWidth: "100%",
                  overflowX: "hidden",
                }}
              >
                <TrackingPage />
                <Footer />
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
